import { Permission } from "../types";

export type PermissionLike = string | Permission;

export const getPermissionKey = (permission: PermissionLike): string =>
  typeof permission === "string" ? permission : permission.key;

export const getPermissionKeys = (
  permissions: PermissionLike[] | null | undefined,
): string[] => (permissions || []).map(getPermissionKey);

export const getPermissionResource = (
  permission: PermissionLike | null | undefined,
): string | undefined => {
  if (!permission) {
    return undefined;
  }

  if (typeof permission === "string") {
    return permission.split(":")[0];
  }

  return permission.resource;
};
